const openContextMenu = ({ commit }, payload) => {
  commit("setContextMenu", payload)
}

export default {
  openContextMenu,
}
